<template>
  <div id="app">
    <keep-alive :include="componentsCache">
      <router-view v-if="isRouterAlive" @hook:mounted="changeRouteCache()" :key="routerViewKey+''"></router-view>
    </keep-alive>
  </div>
</template>
<script>
import { queryEnterpriseInfo,getUserEditFlag} from '@/api/enterprise'

import { getMemberSettingInfo,getMemberUserIdentity,queryUserPackage,queryActivityFlag} from '@/api/user'
import Cookies from "js-cookie";

// import versionTood from '@/utils/versionUpdate';
export default {
  name: 'App',
  data(){
    return{
      userInfo:{},
      isRouterAlive:true,
      componentsCache:['DesignIndex'],
      routerViewKey: 0
    }
  },
  provide() { // 父组件中返回要传给下级的数据
    return {
      reload: this.reload,
      getUserEditFlag:this.getUserEditFlag
    }
  },
  methods:{
    //判断是否限制编辑设计
    async getUserEditFlag(){
      try{
        if(this.userInfo.accountType==this.$t('SubMenu.businessSub')){
          //查询是否允许编辑
          let resFlag = await getUserEditFlag();
          if(resFlag.success){
            this.userInfo.userEditFlag=resFlag.entity
          }
        }
      }finally{
        return this.userInfo.userEditFlag
      }
    },
    //更改语言后刷新数据
    async reload() {
      //提前判断防止控制台继续请求报错
      this.isRouterAlive = false
      let lang='zh'
      if(localStorage.getItem('language')&&localStorage.getItem('language')=='en'){
          lang='en'
      }
      if(this.$i18n.locale!=lang||this.$route.name=='DesignIndex'){
        this.$i18n.locale =lang
        this.changeRouteCache(true)
      }
      if((localStorage.getItem('loginStatus')&&localStorage.getItem('loginStatus')=='true')||Cookies.get("VM_APP_COOKIE")){
        let res2 = await getMemberSettingInfo()
        if(res2&&res2.entity){
          this.userInfo = JSON.parse(JSON.stringify(res2.entity));
        }
      }
      this.$nextTick(async()=>{
        this.isRouterAlive = true
        if((localStorage.getItem('loginStatus')&&localStorage.getItem('loginStatus')=='true')||Cookies.get("VM_APP_COOKIE")){
          localStorage.setItem('loginStatus','true')
          this.$store.commit('changeLoginStatus',true)
          let lang='zh'
          if(localStorage.getItem('language')&&localStorage.getItem('language')=='en'){
              lang='en'
          }
          if(this.$i18n.locale!=lang){
            this.$i18n.locale =lang
            this.changeRouteCache(true)
          }
          await this.getUserData()
        }else{
          localStorage.removeItem('loginStatus')
          this.$store.commit('changeLoginStatus',false)
        }
        if(localStorage.getItem('language')&&localStorage.getItem('language')=='en'){
          document.title='Virtual Engineer'
        }else{
          document.title='数智工程师'
        }
      })
    },
    // 请求企业和个人数据，放到userInfo;
    async getUserData() {
      try {
          if(this.userInfo.userLanguage){
            // console.log(this.userInfo.userLanguage);
            let lang='zh'
            if(this.userInfo.userLanguage&&this.userInfo.userLanguage=='EN_US'){
                lang='en'
            }
            this.$i18n.locale =lang
            if(!localStorage.getItem('language')||localStorage.getItem('language')!==lang){
              localStorage.setItem('language',lang);
              this.reload()//全局重新加载
              return
            }
          }
          //存储认证状态
          if(this.userInfo.userStatus){
            switch(this.userInfo.userStatus){
                case "NORMAL":
                  localStorage.setItem("userStatus",'passed');
                  this.$store.commit('changeUserStatus','passed');
                  break;
                default:
                  localStorage.setItem("userStatus",'reject');
                  this.$store.commit('changeUserStatus','reject');
            }
          }
          
          //存储试用状态(屏蔽)
          localStorage.setItem("trialStage", this.userInfo.trialApplyStatus);
          this.$store.commit('changeTrialStage',this.userInfo.trialApplyStatus)
          localStorage.setItem("accountType", this.userInfo.accountType);
          
          //存储账户类型标签(屏蔽)
          let res3 = await getMemberUserIdentity()
          if(res3.success){
            if(!res3.entity.userVipType){
              this.userInfo.tagBtnText=''
            }else{
              switch(res3.entity.userVipType){
                case "COMMON_VIP":this.userInfo.tagBtnText=this.$t('Tag.CommonVIP');break;
                case "TRIAL_VIP":this.userInfo.tagBtnText=this.$t('Tag.TrialVIP');break;
                case "ENTERPRISE_VIP":this.userInfo.tagBtnText=this.$t('Tag.EnterpriseVIP');break;
              }
              if(res3.entity.expireTimeStamp&&(new Date().getTime()>=res3.entity.expireTimeStamp)){
                this.userInfo.tagBtnText=this.$t('SubMenu.expired');
              }
            }
          }
          this.userInfo.userEditFlag=true
          if(this.userInfo.accountType=='BUSINESS'||this.userInfo.accountType=='BUSINESS_SUB'){
            let res = await queryEnterpriseInfo();
            this.userInfo={...res.entity,...this.userInfo}
            switch(res.entity.accountStatus){
              case 'CERTIFIED':this.userInfo.accountStatus=this.$t('SubMenu.certified');break;
              case 'NO_CERTIFIED':this.userInfo.accountStatus=this.$t('SubMenu.notCertified');break;
            }
            try{
              if(this.userInfo.accountType=='BUSINESS_SUB'){
                //查询是否允许编辑
                let resFlag = await getUserEditFlag();
                if(resFlag.success){
                  this.userInfo.userEditFlag=resFlag.entity
                }
              }
            }finally{}
          }
          //this.userInfo.userEditFlag=false//todo 测试
          switch(this.userInfo.accountType){
            case 'PERSON':
            this.userInfo.accountType = this.$t('SubMenu.person');
            break;
            case 'BUSINESS':this.userInfo.accountType = this.$t('SubMenu.businessMaster');break;
            case 'BUSINESS_SUB':this.userInfo.accountType = this.$t('SubMenu.businessSub');break;
          }
          
          //查询是否在活动期
          this.userInfo.activityFlag=false
          let activityRes=await queryActivityFlag({activityCode:'PRODUCT_LAUNCH_ACTIVITY'})
          if(activityRes.success&&activityRes.entity){
            this.userInfo.activityFlag=activityRes.entity
          }
          //查询用户套餐
          let packageRes=await queryUserPackage()
          if(packageRes.success){
            this.userInfo={...this.userInfo,...packageRes.entity}
          }
        this.$store.commit('changeUserInfo',this.userInfo)
        this.$forceUpdate()
      } catch (err) {
        //统一处理异常
        // console.error (err)
      }finally{
      }
    },
    changeRouteCache(force){
      if(this.$route.name!='DesignIndex'||force){
        if (window.requestIdleCallback) {
          window.requestIdleCallback(() => {
            this.$nextTick(()=>{this.componentsCache=[]})
            setTimeout(()=>{
              this.$nextTick(()=>{
                this.$nextTick(()=>{
                  setTimeout(()=>{
                    this.componentsCache=['DesignIndex']
                  },0)
                })
              })
            },0)
          })
        } else {
          setTimeout(()=>{
            this.$nextTick(()=>{this.componentsCache=[]})
            setTimeout(()=>{
              this.$nextTick(()=>{
                this.$nextTick(()=>{
                  setTimeout(()=>{
                    this.componentsCache=['DesignIndex']
                  },0)
                })
              })
            },0)
          },0)
        }
      }
    }
  },
  async created(){
    window.addEventListener("setItemEvent",()=>{
      const computedUse = () => {
        let cache = 0
        if(localStorage&&localStorage.length){
          for(let key in localStorage) {
            if (localStorage.hasOwnProperty(key)&&key!='setItem') {
              cache += localStorage.getItem(key).length
            }
          }
        }
        return (cache / 1024).toFixed(2)
      }
      
      (async () => {
        const useCache = computedUse()
        if(useCache>5000){
          //移除用户信息
          let arr=Object.keys(localStorage)
          arr.forEach((item)=>{
            if(item.includes('status')
            ||item.includes('/design')
            ||item.includes('productUUID')
            ||item.includes('queryList')
            ||item.includes('contrast')
            ||item.includes('/dxf')
            ||item.includes('queryList')
            ||item.includes('tempArr')
            ||item.includes('/create')){
              localStorage.removeItem(item)
            }
          })
          this.$router.go(0)
        }
      })()
    })
  },
  destroyed(){
  },
  watch:{
    $route: {
        handler(newVal,oldVal) {
          if(newVal&&newVal.path&&oldVal&&oldVal.path){
            if(newVal.path.split('/')[1]!=oldVal.path.split('/')[1]&&newVal.name!=='NotFound'){
              this.reload()
            }
            // if (oldVal.name === 'DesignIndex') {
            //   this.routerViewKey += 1
            // }
          }
        },
        deep: true,
    },
  },
}
</script>
<style lang="scss">
html,
body {
  height: 100%;
  body{
    min-width: 1080px;
  }
}
#app {
  height: 100%;
  font-family:Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  input, textarea {
    user-select: text;
    -moz-user-select: text;
    -webkit-user-select: text;
    -ms-user-select: text;
  }
}

</style>
